"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const areas = [{
  titulo: "Automatización de procesos",
  detalle: "Lo que hoy hace el equipo a mano, lo hace un sistema todo el tiempo. Workflows que eliminan trabajo manual. Make como motor. OCR e IA cuando aplican, integraciones, reportes programados."
}, {
  titulo: "Infraestructura operativa",
  detalle: "El negocio tiene un panel de control, no un Excel compartido. Monday, CRMs (HubSpot, Salesforce, Pipedrive), ERPs (Odoo). El sistema operativo del negocio."
}, {
  titulo: "Integración de sistemas",
  detalle: "Los sistemas dejan de ser islas. Sincronización entre plataformas, middleware custom, conectores que no existen en el mercado."
}, {
  titulo: "AI ops",
  detalle: "La IA hace el trabajo repetitivo de análisis que hoy consume al equipo. Agentes y workflows con LLMs en producción. Stack agnóstico: OpenAI, Gemini, Claude según proyecto."
}];
export default function AreasYCobranzaPartner() {
  return <>
      <BloqueAreas />
      <BloqueComoCobramos />
    </>;
}
function BloqueAreas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="partner-areas" id="areas-especializacion" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`mb-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-6">
            Cuatro frentes técnicos.
          </h2>

          <p className="font-sans text-lg text-muted-foreground leading-relaxed max-w-2xl">
            Cada engagement combina los que el negocio necesita.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12">
          {areas.map((area, i) => <AreaItem key={i} area={area} index={i} />)}
        </div>
      </div>
    </section>;
}
function AreaItem({
  area,
  index
}: {
  area: {
    titulo: string;
    detalle: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <h3 className="font-serif text-2xl md:text-3xl text-foreground font-normal leading-tight mb-3">
        {area.titulo}
      </h3>
      <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed">
        {area.detalle}
      </p>
    </div>;
}
function BloqueComoCobramos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="partner-cobranza" id="como-cobramos-partner" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-10">
            Cómo cobramos.
          </h2>

          <div className="space-y-6 font-sans text-lg md:text-xl text-foreground/90 leading-relaxed max-w-2xl">
            <p>Iguala mensual fija. No por hora.</p>

            <p>
              Compromiso inicial de seis meses para que el trabajo tenga horizonte. Después, mes a mes.
            </p>

            <p>
              Cada mes priorizamos juntos. Si cambia la prioridad del negocio, pivotamos. Sin renegociación.
            </p>

            <p className="text-muted-foreground italic">
              El software siempre vive en cuentas del cliente. No revendemos licencias ni hacemos markup.
            </p>
          </div>
        </div>
      </div>
    </section>;
}